import { NotificationManager } from 'react-notifications'

// error handle funtion
export function errorHandler (errors) {
  if (errors?.response?.status === 500 && errors.response?.data?.message) {
    NotificationManager.error(errors.response.data.message)
    return errors
  }

  if (errors?.response?.status === 401) {
    NotificationManager.error(errors.response.data.message || errors.response.data.detail)
    return errors
  }

  if (errors?.response?.status === 400) {
    NotificationManager.error(errors.response.data.error|| errors.response.data.errors || errors.response.data.message || errors.message || errors?.response.data.error)
    return errors
  }
  if (errors.response?.data?.message) {
    NotificationManager.error(errors.response.data.message)
    return errors
  }

  if (errors?.response?.data[0]) {
    NotificationManager.error(errors.response.data[0])
    return errors
  }
}
